/*
* Chat Components
*/
import TenanatChatTrigger from "@shared/components/chat/TenantChatTrigger.vue"
import TenantChatContainer from "@shared/components/chat/TenantChatContainer.vue"
import TenantChatContainerPWA from "@shared/components/chat/TenantChatContainerPWA.vue"
import ChatToolBox from "@shared/components/chat/ChatToolBox.vue"
import InnerChatToolBox from "@shared/components/chat/InnerChatToolBox.vue"
import ChatTime from "@shared/components/chat/ChatTime.vue"


const ambitionChat = {
    TenanatChatTrigger,
    TenantChatContainer,
    TenantChatContainerPWA,
    ChatToolBox,
    InnerChatToolBox,
    ChatTime
};


export default {
  ...ambitionChat
}
